import { MessageBus } from "@spscommerce/services";

export class RedirectService {
    messageBus = new MessageBus();

    backToLogin() {
        this.messageBus.send("refreshCommercePlatform");
    }

    goToTrainingCenter(env: string) {
        const host =
            env === "prod"
                ? "trainingcenter.spscommerce.com"
                : "training-center-sandbox.schoolkeep.com";
        // Generate the correct direct enrollment link for analytics users per env
        // (a direct course enrollment is used in test)
        const enrollment_path =
            env === "prod"
                ? "/g/36cc2dcd376702775000e68293f8e30dd57c18b0"
                : "/c/97759929005f0d4c3973dc703586ccb624542143";
        // We can only open a new tab because we are running within an iframe
        window.open(`https://${host}${enrollment_path}`);
    }

    setUserToken(token: string) {
        this.messageBus.send("setUserToken", token);
    }
}
